/**
 * Created by hp on 2017/8/8.
 */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import ReactSwipe from 'react-swipe';

class WKSlide extends Component {
    constructor(props) {
        super(props);
        this.handleSlideLeft = this.handleSlideLeft.bind(this);
        this.handleSlideRight = this.handleSlideRight.bind(this);
        this.handleSlideTarget = this.handleSlideTarget.bind(this);
        this.handleCallback = this.handleCallback.bind(this);

        let clientWidth = document.body.clientWidth;
        let height = clientWidth > 480 ? parseInt(480 / 2.92, 10) : parseInt(clientWidth / 2.92, 10);

        this.state = {
            slideIndex: 0,
            height: height,
            options: Object.assign(this.props.wkSlide.options, {callback: this.handleCallback})
        };
    }

    handleCallback(index) {
        this.setState({slideIndex: index});
    }

    handleSlideLeft() {
        this.refs.reactSwipe.prev();
    }

    handleSlideRight() {
        this.refs.reactSwipe.next();
    }

    handleSlideTarget(e) {
        let index = e.currentTarget.dataset.index;
        this.setState({slideIndex: parseInt(index, 10)});
        this.refs.reactSwipe.slide(index);
    }

    render() {
        const {selectCategory} = this.props
        const {content} = this.props.wkSlide;
        const {options, slideIndex, height} = this.state;
        if (content.length === 0) {
            return <div className="wk-slide" style={{height: height + 'px'}}></div>;
        }
        let inviterId = selectCategory === 0 ? 43610930 : 43611021;

        return (
            <div className="wk-slide" style={{height: height + 'px'}}>
                <ReactSwipe ref="reactSwipe" swipeOptions={options}>
                    {content.map((item, index) => (
                        <div key={item.id}>
                            <a href={
                                (item.type === 'other' || item.type === 'schedule' || item.type === 'link') ? item.url : `/${item.type}/${item.id}?st=lzwk_banner&inviter_id=${inviterId}`}>
                                <img src={item.image}/>
                            </a>
                        </div>
                    ))}
                </ReactSwipe>
                <span className="wks-left" onClick={this.handleSlideLeft}><i className="iconfont icon-jiantou"/></span>
                <span className="wks-right" onClick={this.handleSlideRight}><i className="iconfont icon-202"/></span>
                <div className="wks-points">
                    {content.map((item, index) => (
                        <span key={index} data-index={index} className={slideIndex === index ? "wks-points-active" : ""}
                              onClick={this.handleSlideTarget}/>
                    ))}
                </div>
            </div>
        )
    }
}

export default connect((state) => ({
    wkSlide: state.wk.wkSlide,
    selectCategory: state.main.selectCategory
}))(WKSlide)



// WEBPACK FOOTER //
// ./src/components/wk/WKSlide.js